import { graphql } from '@generated/gql';

export const FETCH_DOWNLOAD_ALL_FORMS_USER = graphql(/** GraphQL */ `
  query downloadAllFormsFetchUser($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        id: stringId
        type
        firstName
        lastName
        entityName
      }
    }
  }
`);

export const FETCH_DOWNLOAD_ALL_FORMS_CLIENT_GROUP = graphql(/** GraphQL */ `
  query downloadAllFormsFetchClientGroup($clientGroupId: SafeString!) {
    fetchClientGroup(input: { clientGroupId: $clientGroupId }) {
      clientGroup {
        id: stringId
        name
      }
    }
  }
`);

export const FETCH_FORM_COMPLETION_PDF = graphql(/** GraphQL */ `
  query downloadAllFormsFetchFormCompletion($formCompletionId: ObjectID!) {
    fetchFormCompletion(formCompletionId: $formCompletionId) {
      id
      unsignedUrl
      resolvedPdfFileName {
        ...FormTranslatedString
      }
      translatedName {
        ...FormTranslatedString
      }
      unsignedDocument {
        downloadUrl
        fileName
      }
    }
  }
`);
